"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeighborUpdateRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const ContentDeliveryRpcRemote_1 = require("../ContentDeliveryRpcRemote");
class NeighborUpdateRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    updateContacts(neighborDescriptors) {
        const ownNodeId = (0, dht_1.toNodeId)(this.options.localPeerDescriptor);
        const newPeerDescriptors = neighborDescriptors.filter((peerDescriptor) => {
            const nodeId = (0, dht_1.toNodeId)(peerDescriptor);
            return nodeId !== ownNodeId && !this.options.neighbors.getIds().includes(nodeId);
        });
        newPeerDescriptors.forEach((peerDescriptor) => this.options.nearbyNodeView.add(new ContentDeliveryRpcRemote_1.ContentDeliveryRpcRemote(this.options.localPeerDescriptor, peerDescriptor, this.options.rpcCommunicator, NetworkRpc_client_1.ContentDeliveryRpcClient)));
    }
    createResponse(removeMe) {
        return {
            streamPartId: this.options.streamPartId,
            neighborDescriptors: this.options.neighbors.getAll().map((neighbor) => neighbor.getPeerDescriptor()),
            removeMe
        };
    }
    // INeighborUpdateRpc server method
    async neighborUpdate(message, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const remoteNodeId = (0, dht_1.toNodeId)(senderPeerDescriptor);
        this.updateContacts(message.neighborDescriptors);
        if (!this.options.neighbors.has(remoteNodeId) && !this.options.ongoingHandshakes.has(remoteNodeId)) {
            return this.createResponse(true);
        }
        else {
            const isOverNeighborCount = this.options.neighbors.size() > this.options.neighborTargetCount
                // Motivation: We don't know the remote's neighborTargetCount setting here. We only ask to cut connections
                // if the remote has a "sufficient" number of neighbors, where "sufficient" means our neighborTargetCount
                // setting.
                && message.neighborDescriptors.length > this.options.neighborTargetCount;
            if (!isOverNeighborCount) {
                this.options.neighborFinder.start();
            }
            else {
                this.options.neighbors.remove(remoteNodeId);
            }
            return this.createResponse(isOverNeighborCount);
        }
    }
}
exports.NeighborUpdateRpcLocal = NeighborUpdateRpcLocal;
//# sourceMappingURL=NeighborUpdateRpcLocal.js.map